/**
 * EvidenceFragment — canonical structured evidence contract for CGCL carry-forward and continuity work.
 * Only populate fields from real source data; never invent values.
 * (see src/lib/behavior/viewModels/buildLeadershipRecordItems.ts)
 */

export type EvidenceFragmentSourceType =
  | "transcript"
  | "reflection"
  | "coach_note"
  | "practice_summary"
  | "coach_chat"
  | "leader_memory_event"
  | "bi_observation"
  | "context_graph_node";

export interface EvidenceFragment {
  sourceType: EvidenceFragmentSourceType;
  sourceId: string;
  title?: string;
  occurredAt?: string;
  quote?: string;
  speakerLabel?: string;
  timestampStart?: string;
  timestampEnd?: string;
  displayLabel?: string;
  displayUrl?: string;
}

/** Creates a valid EvidenceFragment. Only populate fields from real source data — never invent values. */
export function createEvidenceFragment(
  sourceType: EvidenceFragmentSourceType,
  sourceId: string,
  overrides?: Partial<EvidenceFragment>
): EvidenceFragment {
  return { sourceType, sourceId, ...overrides };
}
